import { forwardRef } from "react";

const Hotspot = forwardRef(({ area, active, onSelect, testId, className = "", style }, ref) => (
  <button
    ref={ref}
    type="button"
    onClick={() => onSelect(area.slug)}
    aria-label={area.label}
    aria-pressed={active}
    data-testid={testId}
    className={`hs3d ${active ? "is-active" : ""} ${className}`}
    style={style}
  >
    <span className="hs3d-dot" aria-hidden="true" />
    <span className="hs3d-label" aria-hidden="true">{area.label}</span>
  </button>
));
Hotspot.displayName = "Hotspot";
export default Hotspot;
